// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCategoriesRequestModel from '../../model/get-categories-request-model';
import GetCategoriesRequestDTO from '../dto/get-categories-request-dto';
import dtoSchema from '../schemas/get-categories-request-schema';

export default abstract class GetCategoriesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCategoriesRequestDTO>) {
    super();
    if (data) {
      this.language = data.language;
    }
  }
  /**
  */
  language?: string;

  static toModel(dto: DeepPartial<GetCategoriesRequestDTO>): GetCategoriesRequestModel;
  static toModel(dto: DeepPartial<GetCategoriesRequestDTO> | undefined | null): GetCategoriesRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCategoriesRequestDTO> | undefined | null): GetCategoriesRequestModel | undefined {
    return dto ? new GetCategoriesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCategoriesRequestModel> | GetCategoriesRequestModel): GetCategoriesRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      language: unwrapped.language,
    } as GetCategoriesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCategoriesRequestModel, can not map to GetCategoriesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
